/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_ScoreInputs */

const cs_order_score = /** @type {(inputs: Order_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skóre`)
};

const en_order_score = /** @type {(inputs: Order_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {Order_ScoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_score = /** @type {((inputs?: Order_ScoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_ScoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_score(inputs)
	return cs_order_score(inputs)
});